/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_Stage_LeadInputs */

const en_mk_abt_stage_lead = /** @type {(inputs: Mk_Abt_Stage_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We write this down so you can decide with your eyes open, not so we sound bigger than we are.`)
};

const id_mk_abt_stage_lead = /** @type {(inputs: Mk_Abt_Stage_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami menuliskannya supaya Anda bisa memutuskan dengan mata terbuka, bukan supaya terdengar lebih besar dari yang sebenarnya.`)
};

/**
* | output |
* | --- |
* | "We write this down so you can decide with your eyes open, not so we sound bigger than we are." |
*
* @param {Mk_Abt_Stage_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_stage_lead = /** @type {((inputs?: Mk_Abt_Stage_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_Stage_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_stage_lead(inputs)
	return en_mk_abt_stage_lead(inputs)
});